import { useEditorStore } from '../../stores/editorStore';
import ModeSelector from './ModeSelector';
import FileActions from './FileActions';

export default function Toolbar() {
  const { levelId, mode, entityPaletteScope, tool, setTool, undo, redo, historyIndex, history } =
    useEditorStore();
  const isAllEntitiesView = mode === 'entities' && entityPaletteScope === 'all';

  return (
    <div className="toolbar">
      <div className="toolbar-group">
        <span style={{ fontWeight: 600, marginRight: 8 }}>Imbasion Editor</span>
      </div>

      <div className="toolbar-separator" />

      <FileActions />

      <div className="toolbar-separator" />

      <ModeSelector />

      <div className="toolbar-separator" />

      <div className="toolbar-group">
        <button
          className={`toolbar-button ${tool === 'select' ? 'active' : ''}`}
          onClick={() => setTool('select')}
          title="Select (V)"
        >
          Select
        </button>
        <button
          className={`toolbar-button ${tool === 'move' ? 'active' : ''}`}
          onClick={() => setTool('move')}
          title="Move (M)"
        >
          Move
        </button>
      </div>

      <div className="toolbar-separator" />

      <div className="toolbar-group">
        <button
          className="toolbar-button"
          onClick={() => {
            console.log('Undo clicked, historyIndex:', historyIndex, 'history.length:', history.length);
            undo();
          }}
          disabled={historyIndex <= 0}
          title="Undo (Ctrl+Z)"
        >
          Undo ({historyIndex}/{history.length})
        </button>
        <button
          className="toolbar-button"
          onClick={() => {
            console.log('Redo clicked, historyIndex:', historyIndex, 'history.length:', history.length);
            redo();
          }}
          disabled={historyIndex >= history.length - 1}
          title="Redo (Ctrl+Shift+Z)"
        >
          Redo
        </button>
      </div>

      <div style={{ flex: 1 }} />

      {isAllEntitiesView ? (
        <div className="toolbar-group">
          <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
            Viewing: all entities
          </span>
        </div>
      ) : levelId && (
        <div className="toolbar-group">
          <span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
            Editing: {levelId}
          </span>
        </div>
      )}
    </div>
  );
}
